<div class="py-3">
    @if(receipts.length >= storeOptions.length) {
        <div class="flex justify-end m-3 mt-0">
            <p-button
                icon="pi pi-plus" 
                label="Add Receipt"
                severity="primary"
                [outlined]="true"
                (click)="addReceipt()" />
        
        </div>
    }
    @for (receipt of receipts; track $index; let i = $index) {
        <div class="mb-3 p-4 border border-gray-100">
            <div class="flex flex-col gap-2">
                <p-floatlabel variant="in"  class="mb-2">
                    <!-- <p-autocomplete id="store" [(ngModel)]="receipt.storeName" [dropdown]="true" [suggestions]="filteredStoreOptions" optionLabel="name" (completeMethod)="searchStore($event)" /> -->
                    <p-select [(ngModel)]="receipt.storeName" [editable]="true" [options]="storeOptions" optionLabel="name" optionValue="code" class="w-full" (blur)="setUploadedAllReceipts()" (onChange)="setUploadedAllReceipts()"/>
                    <label for="city">Store Name</label>
                </p-floatlabel>
                <p-floatlabel variant="in" class="mb-2">
                    <input pInputText id="receiptTotal" [(ngModel)]="receipt.total" autocomplete="off" class="w-full" (blur)="setUploadedAllReceipts()"/>
                    <label for="receiptTotal">Receipt Total</label>
                </p-floatlabel>
                <div class="flex flex-wrap gap-2">
                    @if (!utilityService.cameraPermissionStatus?.granted) {
                        <p-message severity="warn">Need camera permission to capture photo and upload. &nbsp;<a style="text-decoration: underline; color:#a16207; cursor: pointer;" (click)="utilityService.requestCameraPermission()">Grant Permission</a></p-message>
                    }
                    @if(receipt.receiptImage) {
                        <p-image [src]="receipt.receiptImage.downloadUrl" alt="Image" width="150" [preview]="true" />
                    } @else {
                        <p-fileupload 
                            #fileupload [style]="{'background-color': '#4D7935', 'color':'white', 'border': 'none'}" 
                            severity="primary" 
                            class="flex" mode="basic" name="image" 
                            chooseIcon="pi pi-upload" 
                            [customUpload]="true" 
                            [multiple]="true" 
                            accept="image/*" 
                            (uploadHandler)="uploadReceipts($event, fileupload, i)" 
                            [auto]="true" 
                            chooseLabel="Upload Receipt Image" />
                    }
                </div>
                @if(receipts.length > 1) {
                    <div class="flex gap-3 items-center">
                        <!-- <p-button
                            icon="pi pi-add" 
                            label="Save Receipt"
                            severity="primary"
                            [outlined]="false"
                            [disabled]="!receipt.total || !receipt.storeName || !receipt.receiptImage"
                            (click)="saveReceipt()" /> -->
                        <p-button
                            icon="pi pi-times" 
                            label="Delete Receipt"
                            severity="danger"
                            [outlined]="true"
                            (click)="deleteReceipt(i)" />

                    </div>
                } @else {
                    <div class="text-sm text-gray-500">
                        To delete this receipt, please add another receipt.
                    </div>
                }
            </div>
        </div>
    }
    <div class="absolute z-10 bottom-0 right-0 left-0 h-12 w-full bg-green-100">
        <div>
            <p-button
                [label]="'Save Receipts'"
                [text]="true"
                [size]="'large'"
                severity="success"
                (click)="close()"
                [disabled]="!uploadedAllReceipts"
                [style]="{background: '#4D7935', width: '100%', 'border-radius': '0'}"
                class="[&_button]:text-white [&_button]:w-full [&_.p-button-icon]:text-md" />
        </div>
    </div>
    
</div>